import { Directive, Input, OnInit, Renderer2, ElementRef } from '@angular/core';
import { UserService } from '../../modules/auth/services/user.service';
import { User } from '../../modules/auth/models/user.model';

@Directive({
  selector: '[appUserDisplay]'
})
export class UserDisplayDirective implements OnInit {
  @Input('appUserDisplay') card: string;
  @Input() displayProperties: string[];

  constructor(
    private userService: UserService,
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  ngOnInit() {
    this.userService.getuserbycard(this.card).then((user: User) => {
      const userData = this.renderUserData(user);
      this.displayUserData(user, userData);
    }).catch(error => {
      console.error('Error fetching user:', error);
      this.renderer.setProperty(this.el.nativeElement, 'textContent', 'Error fetching user data');
    });
  }

  private renderUserData(user: User): any {
    const userData: any = {};

    this.displayProperties.forEach(prop => {
      const value = user[prop];
      if (value !== undefined && value !== null) {
        userData[prop] = value;
      }
    });

    return userData;
  }

  private displayUserData(user: User, userData: any) {
    this.renderer.setProperty(this.el.nativeElement, 'textContent', '');
      const text = `${user.email}`;
      const textElement = this.renderer.createText(text);
      this.renderer.appendChild(this.el.nativeElement, textElement);
  }
}
